import { useSelector } from "react-redux";

const REJECTED_NAMES = {
    "cheaper_elsewhere": "Sain soodsama pakkumise",
    "over_budget": "Pakkumine ületab eelarvet",
    "trip_cancelled": "Reis jääb ära",
    "other": "Pakkumine ei sobi muul põhjusel",
    "cancelled_via_platform": "Tagasi lükatud platvormi kaudu"
}

function QueryResponseRejectedReason({ id }) {
    const data = useSelector((state) => state.knownData[id]);

    console.log("db11:", data);

    return (
        <div className="column g32">
            <h2>Pakkumine tagasi lükatud</h2>
            
            <div className="column g8">
                <b>Põhjus</b>
                <p>{data["query_response_reject_reason_reason"] ? REJECTED_NAMES[data["query_response_reject_reason_reason"]] : '-'}</p>
            </div>
        </div>
    );
}

export default QueryResponseRejectedReason;